import { twMerge } from "tailwind-merge";

import { BREAKPOINTS } from "@/globals";

export enum WRAPPER_MODE {
    HBottomAround = "HBottomAround",
    HBottomBetween = "HBottomBetween",
    HBottomCenter = "HBottomCenter",

    HBottomLeft = "HBottomLeft",
    HBottomRight = "HBottomRight",
    HCenterAround = "HCenterAround",

    HCenterBetween = "HCenterBetween",
    HCenterCenter = "HCenterCenter",
    HCenterLeft = "HCenterLeft",

    HCenterRight = "HCenterRight",
    HCenterStretch = "HCenterStretch",
    HLeftStretch = "HLeftStretch",

    HRightStretch = "HRightStretch",
    HTopAround = "HTopAround",
    HTopBetween = "HTopBetween",

    HTopCenter = "HTopCenter",
    HTopLeft = "HTopLeft",
    HTopRight = "HTopRight",

    VBottomCenter = "VBottomCenter",
    VBottomLeft = "VBottomLeft",
    VBottomRight = "VBottomRight",

    VBottomStretch = "VBottomStretch",
    VCenterAround = "VCenterAround",
    VCenterBetween = "VCenterBetween",

    VCenterCenter = "VCenterCenter",
    VCenterLeft = "VCenterLeft",
    VCenterRight = "VCenterRight",

    VCenterStretch = "VCenterStretch",
    VLeftAround = "VLeftAround",
    VLeftBetween = "VLeftBetween",

    VRightAround = "VRightAround",
    VRightBetween = "VRightBetween",
    VTopCenter = "VTopCenter",

    VTopLeft = "VTopLeft",
    VTopRight = "VTopRight",
    VTopStretch = "VTopStretch",
}

export const WRAPPER_STYLES: Record<WRAPPER_MODE, (breakpoint?: BREAKPOINTS) => string> & {
    base: () => string;
} = {
    base: () => "flex",
    [WRAPPER_MODE.HLeftStretch]: () => twMerge(WRAPPER_STYLES.base(), "flex-row justify-start"),
    [WRAPPER_MODE.HCenterStretch]: () => twMerge(WRAPPER_STYLES.base(), "flex-row justify-center"),
    [WRAPPER_MODE.HRightStretch]: () => twMerge(WRAPPER_STYLES.base(), "flex-row justify-end"),
    [WRAPPER_MODE.HTopBetween]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row justify-between items-start"),
    [WRAPPER_MODE.HCenterBetween]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row justify-between items-center"),
    [WRAPPER_MODE.HBottomBetween]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row justify-between items-end"),
    [WRAPPER_MODE.HTopAround]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row justify-around items-start"),
    [WRAPPER_MODE.HCenterAround]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row justify-around items-center"),
    [WRAPPER_MODE.HBottomAround]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row justify-around items-end"),
    [WRAPPER_MODE.VTopStretch]: () => twMerge(WRAPPER_STYLES.base(), "flex-col justify-start"),
    [WRAPPER_MODE.VCenterStretch]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-center items-stretch"),
    [WRAPPER_MODE.VBottomStretch]: () => twMerge(WRAPPER_STYLES.base(), "flex-col justify-end"),
    [WRAPPER_MODE.VLeftBetween]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-between items-start"),
    [WRAPPER_MODE.VCenterBetween]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-between items-center"),
    [WRAPPER_MODE.VRightBetween]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-between items-end"),
    [WRAPPER_MODE.VLeftAround]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-around items-start"),
    [WRAPPER_MODE.VCenterAround]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-around items-center"),
    [WRAPPER_MODE.VRightAround]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-around items-end"),
    [WRAPPER_MODE.HCenterLeft]: (breakpoint) =>
        twMerge(
            WRAPPER_STYLES.base(),
            breakpoint === BREAKPOINTS.sm
                ? "sm:flex-row sm:justify-start sm:items-center"
                : breakpoint === BREAKPOINTS.md
                  ? "md:flex-row md:justify-start md:items-center"
                  : "flex-row justify-start items-center",
        ),

    [WRAPPER_MODE.VTopCenter]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-start items-center"),
    [WRAPPER_MODE.HCenterRight]: (breakpoint) =>
        twMerge(
            WRAPPER_STYLES.base(),
            breakpoint === BREAKPOINTS.sm
                ? "sm:flex-row sm:justify-end sm:items-center"
                : breakpoint === BREAKPOINTS.md
                  ? "md:flex-row md:justify-end md:items-center"
                  : "flex-row justify-end items-center",
        ),
    [WRAPPER_MODE.VTopLeft]: (breakpoint) =>
        twMerge(
            WRAPPER_STYLES.base(),
            breakpoint === BREAKPOINTS.sm ? "sm:flex-col sm:items-start" : "flex-col items-start",
        ),
    [WRAPPER_MODE.VTopRight]: (breakpoint) =>
        twMerge(
            WRAPPER_STYLES.base(),
            breakpoint === BREAKPOINTS.md ? "md:flex-col md:items-end" : "flex-col items-end",
        ),
    [WRAPPER_MODE.VCenterLeft]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col items-start justify-center"),
    [WRAPPER_MODE.VCenterCenter]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-center items-center "),
    [WRAPPER_MODE.VCenterRight]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-center items-end"),
    [WRAPPER_MODE.VBottomLeft]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-end items-start"),
    [WRAPPER_MODE.VBottomCenter]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-end items-center"),
    [WRAPPER_MODE.VBottomRight]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-col justify-end items-end"),
    [WRAPPER_MODE.HTopLeft]: (breakpoint) =>
        twMerge(
            WRAPPER_STYLES.base(),
            breakpoint === BREAKPOINTS.md
                ? "md:flex-row md:items-start md:justify-start"
                : breakpoint === BREAKPOINTS.lg
                  ? "lg:flex-row lg:items-start lg:justify-start"
                  : "flex-row items-start justify-start",
        ),
    [WRAPPER_MODE.HTopCenter]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row items-start justify-center"),
    [WRAPPER_MODE.HTopRight]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row items-start justify-end"),
    [WRAPPER_MODE.HCenterCenter]: (breakpoint) =>
        twMerge(
            WRAPPER_STYLES.base(),
            breakpoint === BREAKPOINTS.sm
                ? "sm:flex-row sm:items-center sm:justify-center"
                : breakpoint === BREAKPOINTS.md
                  ? "md:flex-row md:items-center md:justify-center"
                  : "flex-row items-center justify-center",
        ),
    [WRAPPER_MODE.HBottomLeft]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row items-end justify-start"),
    [WRAPPER_MODE.HBottomCenter]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row items-end justify-center"),
    [WRAPPER_MODE.HBottomRight]: () =>
        twMerge(WRAPPER_STYLES.base(), "flex-row items-end justify-end"),
};
